import { styled } from "@mui/material/styles";
import { Button, Grid } from "@mui/material";

export const AmountBlock = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  gap: "5px",
});

export const StatusIndicator = styled(Grid, {
  shouldForwardProp: (props) => props !== "isRejected" && props !== "isApproved" && props !== "isCancelled",
})<{ isRejected: boolean; isApproved: boolean; isCancelled: boolean }>(
  ({ isApproved, isRejected, isCancelled, theme: { palette } }) => ({
    backgroundColor: isCancelled
      ? palette.grey[400]
      : isRejected
      ? palette.warning.light
      : isApproved
      ? palette.success.light
      : palette.primary.light,
    textDecoration: isRejected || isCancelled ? "line-through" : "",
    width: "100%",
    color: palette.primary.contrastText,
    borderRadius: "5px",
    padding: "5px",
    "&:hover": {
      cursor: "pointer",
    },
    textAlign: "center",
  })
);

export const AbsensesMainContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const ExtrahoursMainContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
});

export const ExtrahoursAmount = styled(Grid)({
  fontSize: "1em",
  fontWeight: "bold",
  color: "darkblue",
});

export const ClientVendotAmountBlock = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
});

export const ClientVendorInfo = styled(Grid)({
  display: "flex",
  flexDirection: "column",
});

export const AmountContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "5px",
  justifyContent: "flex-end",
});

export const ExpenseInfoContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
});

export const ExpenseIconContainer = styled(Grid)({
  width: "40px",
});
